import { render, staticRenderFns } from "./BizEnterprisePensionForm.vue?vue&type=template&id=3a5b441c&"
import script from "./BizEnterprisePensionForm.vue?vue&type=script&lang=js&"
export * from "./BizEnterprisePensionForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports